import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, getDoc, setDoc, collection, getDocs } from 'firebase/firestore';
// ✅ Added Storage imports
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import BackHomeButton from '../components/BackHomeButton';

function EditProfile() {
  const [name, setName] = useState('');
  const [school, setSchool] = useState('');
  const [board, setboard] = useState('');
  const [standard, setStandard] = useState('');
  const [city, setCity] = useState('');
  const [user, setUser] = useState(null);
  const [created_dt, setcreated_dt] = useState(null);

  // ✅ NEW STATES
  const [bio, setBio] = useState('');
  const [avatarUrl, setAvatarUrl] = useState('');
  const [avatarFile, setAvatarFile] = useState(null);
  const [supportedStandards, setSupportedStandards] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const [cityOptions, setCityOptions] = useState([]);
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [paiduser, setpaiduser] = useState(false);
  const [paidUser_End_Date, setpaidUser_End_Date] = useState('');
  const [subscriptionMonths, setsubscriptionMonths] = useState(0);

  const [persona, setPersona] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const state = location.state;
    if (state && state.persona) {
      setPersona(state.persona);
    }
  }, [location.state]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        navigate('/login');
      } else {
        setUser(currentUser);
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchCitySchools = async () => {
      try {
        const citySchoolsSnap = await getDocs(collection(db, 'city_schools_prod'));
        const citySchoolMap = {};
        citySchoolsSnap.forEach((doc) => {
          const data = doc.data();
          if (!citySchoolMap[data.city]) citySchoolMap[data.city] = [];
          if (!citySchoolMap[data.city].includes(data.school)) {
            citySchoolMap[data.city].push(data.school);
          }
        });

const cities = Object.keys(citySchoolMap)
  .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

setCityOptions(cities);

if (city && citySchoolMap[city]) {
  setFilteredSchools(
    citySchoolMap[city].sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    )
  );
}
 else {
          setFilteredSchools([]);
        }
      } catch (error) {
        console.error('Error fetching city-schools:', error);
      }
    };
    fetchCitySchools();
  }, [city]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (user) {
        try {
          const profileDoc = await getDoc(doc(db, 'profiles', user.uid));
          if (profileDoc.exists()) {
            const profileData = profileDoc.data();
            setName(profileData.name || '');
            setSchool(profileData.school || '');
            setStandard(profileData.standard || '');
            setCity(profileData.city || '');
            setcreated_dt(profileData.created_dt || '');
            setpaiduser(profileData.paidUser || false);
            setpaidUser_End_Date(profileData.paidUser_End_Date || '');
            setsubscriptionMonths(profileData.subscriptionMonths || 0);
            setboard(profileData.board || '');
            
            // ✅ Load existing new fields
            setBio(profileData.bio || '');
            setAvatarUrl(profileData.avatarUrl || '');
            setSupportedStandards(profileData.supportedStandards || []);
            if (!persona && profileData.persona) setPersona(profileData.persona);
          }
        } catch (err) {
          console.error('Error fetching profile data:', err);
        }
      }
    };
    fetchUserProfile();
  }, [user]);

  useEffect(() => {
    const updateSchoolsForCity = async () => {
      try {
        const citySchoolsSnap = await getDocs(collection(db, 'city_schools_prod'));
        const citySchoolMap = {};
        citySchoolsSnap.forEach((doc) => {
          const data = doc.data();
          if (!citySchoolMap[data.city]) citySchoolMap[data.city] = [];
          if (!citySchoolMap[data.city].includes(data.school)) {
            citySchoolMap[data.city].push(data.school);
          }
        });

if (city && citySchoolMap[city]) {
  setFilteredSchools(
    citySchoolMap[city].sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    )
  );
} else {
          setFilteredSchools([]);
        }
      } catch (error) {
        console.error('Error updating schools:', error);
      }
    };
    if (city) {
      updateSchoolsForCity();
    } else {
      setFilteredSchools([]);
      setSchool('');
    }
  }, [city]);

  const handleToggleStandard = (std) => {
    setSupportedStandards(prev => 
      prev.includes(std) ? prev.filter(s => s !== std) : [...prev, std]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      alert('User not logged in');
      return;
    }

    setIsUploading(true);

    let finalAvatarUrl = avatarUrl; // Keep existing URL by default

    try {
      // ✅ 1. Upload new Avatar if a file was selected
      if (avatarFile) {
        const storage = getStorage();
        const fileRef = ref(storage, `avatars/${user.uid}_${Date.now()}`);
        await uploadBytes(fileRef, avatarFile);
        finalAvatarUrl = await getDownloadURL(fileRef);
      }

      // 2. THE PRIVATE DATA
      const privateProfileData = {
        name,
        age: 0,
        gender: 'NA',
        school,
        standard,
        city,
        email: user.email,
        uid: user.uid,
        created_dt: created_dt,
        updated_dt: new Date(),
        paidUser: paiduser,
        paidUser_End_Date: paidUser_End_Date,
        subscriptionMonths: subscriptionMonths,
        persona: persona,
        board: board,
        bio: bio,
        avatarUrl: finalAvatarUrl,
        supportedStandards: persona === 'Teacher' ? supportedStandards : []
      };

      // 3. THE PUBLIC DATA
      const publicProfileData = {
        displayName: name,
        role: persona,
        city: city,
        school: school,
        standard: standard,
        board: board,
        email: user.email,
        bio: bio,
        avatarUrl: finalAvatarUrl,
        supportedStandards: persona === 'Teacher' ? supportedStandards : [],
        updated_dt: new Date()
      };

      // Check if city-school pair exists
      const citySchoolsSnap = await getDocs(collection(db, 'city_schools_prod'));
      let citySchoolExists = false;
      citySchoolsSnap.forEach((doc) => {
        const data = doc.data();
        if (
          data.city.toLowerCase() === city.trim().toLowerCase() &&
          data.school.toLowerCase() === school.trim().toLowerCase()
        ) {
          citySchoolExists = true;
        }
      });

      if (!citySchoolExists) {
        await setDoc(doc(collection(db, 'city_schools_prod')), {
          city: city.trim(),
          school: school.trim(),
        });
      }

      // 4. THE DUAL WRITE
      await Promise.all([
        setDoc(doc(db, 'profiles', user.uid), privateProfileData, { merge: true }),
        setDoc(doc(db, 'public_profiles', user.uid), publicProfileData, { merge: true })
      ]);

      alert('Profile updated successfully!');
      navigate('/Old_Home', { state: { persona } });
    } catch (error) {
      console.error('Error saving profile:', error);
      alert('Something went wrong.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.heading}>Edit Profile</h2>
      <form onSubmit={handleSubmit} style={styles.form}>

        <label style={styles.label}>Logged In as: {persona}</label>
        <br />

        {/* ✅ AVATAR UPLOAD */}
        <div style={{ marginBottom: '1.25rem' }}>
          <label style={styles.label}>Profile Picture:</label>
          {avatarUrl && !avatarFile && (
            <div style={{ marginBottom: '10px' }}>
              <img src={avatarUrl} alt="Avatar" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #ddd' }} />
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setAvatarFile(e.target.files[0])}
            style={styles.input}
          />
        </div>

        {/* ✅ BIO TEXT AREA */}
        <label style={styles.label}>Bio (Optional):</label>
        <textarea
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          placeholder="Tell us a little about yourself..."
          style={{ ...styles.input, height: '80px', resize: 'vertical' }}
          maxLength={150}
        />
        <span style={{ fontSize: '10px', color: '#888', marginTop: '-15px', marginBottom: '15px', textAlign: 'right' }}>
          {bio.length}/150
        </span>

        <label style={styles.label}>Student Name:</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          required
          style={styles.input}
        />

        <label style={styles.label}>City:</label>
        <select
          style={styles.input}
          value={city}
          onChange={(e) => setCity(e.target.value)}
          required
        >
          <option value="">Select a city</option>
          {cityOptions.map((c, idx) => (
            <option key={idx} value={c}>{c}</option>
          ))}
        </select>

        <label style={styles.label}>School:</label>
        <select
          style={styles.input}
          value={school}
          onChange={(e) => setSchool(e.target.value)}
          required
        >
          <option value="">Select a school</option>
          {filteredSchools.map((s, idx) => (
            <option key={idx} value={s}>{s}</option>
          ))}
        </select>

        <label style={styles.label}>Board:</label>
        <select
          style={styles.input}
          value={board}
          onChange={(e) => setboard(e.target.value)}
          required
        >
          <option value="">Select a Board</option>
          <option value="ICSE">ICSE</option>
          <option value="CBSE">CBSE</option>
          <option value="OTHERSTATE">Other State Boards</option>
        </select>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', marginBottom: '15px' }}>
          <label style={{ ...styles.label, margin: 0 }}>
            Don’t see your school, city or board?
          </label>
          <button
            type="button"
            style={{ padding: '4px 10px', fontSize: '12px', backgroundColor: '#31e316ff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            onClick={() => navigate('/support')}
          >
            Raise Ticket
          </button>
        </div>

        <label style={styles.label}>{persona === 'Teacher' ? 'Primary Standard:' : 'Standard:'}</label>
        <select
          value={standard}
          onChange={(e) => setStandard(e.target.value)}
          required
          style={styles.select}
        >
          <option value="">Select Standard</option>
          <option value="LKG">LKG</option>
          <option value="UKG">UKG</option>
          {[...Array(12)].map((_, i) => (
            <option key={i + 1} value={i + 1}>{i + 1}</option>
          ))}
        </select>

        {/* ✅ MULTI-SELECT STANDARDS (TEACHERS ONLY) */}
        {persona === 'Teacher' && (
          <div style={{ marginBottom: '1.25rem' }}>
            <label style={styles.label}>Other Standards Supported:</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginTop: '5px' }}>
              {[...Array(12)].map((_, i) => (
                <label key={i + 1} style={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <input
                    type="checkbox"
                    checked={supportedStandards.includes(i + 1)}
                    onChange={() => handleToggleStandard(i + 1)}
                  />
                  Std {i + 1}
                </label>
              ))}
            </div>
          </div>
        )}

        <button type="submit" style={styles.button} disabled={isUploading}>
          {isUploading ? "Saving..." : "Save Profile"}
        </button>
      </form>

      <br></br>

      <BackHomeButton style={{ marginTop: '2rem' }} backState={{ persona }} />

      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2026 Eascode All Rights Reserved.</p>
      </footer>
    </div>
  );
}

const styles = {
  page: { maxWidth: '480px', margin: '2rem auto', padding: '1.5rem 2rem', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 14px rgba(0,0,0,0.1)', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" },
  heading: { textAlign: 'center', marginBottom: '1.8rem', color: '#333', fontWeight: '700', fontSize: '1.9rem' },
  form: { display: 'flex', flexDirection: 'column' },
  label: { marginBottom: '0.3rem', fontWeight: '600', color: '#555' },
  input: { padding: '0.6rem 0.9rem', fontSize: '1rem', borderRadius: '8px', border: '1.5px solid #bbb', marginBottom: '1.25rem' },
  select: { padding: '0.6rem 0.9rem', fontSize: '1rem', borderRadius: '8px', border: '1.5px solid #bbb', marginBottom: '1.25rem', backgroundColor: '#fff' },
  button: { padding: '0.75rem', fontSize: '1.1rem', fontWeight: '600', backgroundColor: '#4285f4', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer' },
  footer: { padding: '1rem', backgroundColor: '#333', color: '#fff', textAlign: 'center', marginTop: '3rem' },
  footerText: { fontSize: '0.9rem' },
};

export default EditProfile;